var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikesFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75605 9.18445C5.5334 9.18445 5.32775 9.09302 5.17717 8.92739L0.564838 3.85806C0.329886 3.59982 0.288871 3.22224 0.461717 2.91829L1.84155 0.583986C1.98217 0.337614 2.24349 0.184448 2.52355 0.184448H8.98738C9.26803 0.184448 9.52935 0.337614 9.66938 0.583986L11.0492 2.91829C11.2226 3.22224 11.181 3.59982 10.9461 3.85806L6.33377 8.92739C6.18318 9.09302 5.97753 9.18445 5.75488 9.18445H5.75605Z",
    fill: "#848874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikesFilled);
export default __webpack_public_path__ + "static/media/likesFilled.ad5a40a3609c289694b1ac519850414d.svg";
export { ForwardRef as ReactComponent };